/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Control } from 'ol/control';

import { ActiveMapState } from '../state/active-map.state';
import { Select, Store } from '@ngxs/store';
import { CustomGeoPosition, UserLocationOptions } from '../state/active-map.model';
import { Observable } from 'rxjs';
import { distinctUntilChanged, switchMapTo, take, tap } from 'rxjs/operators';
import { inject } from '@angular/core';

export class UserLocationComponent extends Control {
    geolocationEnabled$: Observable<boolean> = inject(Store).select(ActiveMapState.geolocationEnabled);
    position$: Observable<CustomGeoPosition> = inject(Store).select(ActiveMapState.position);

    private readonly gotoPositionListener: () => void;

    constructor(optOptions: UserLocationOptions) {
        const options = optOptions;
        if (!options.locationCallback) {
            throw new Error('Location callback is required');
        }
        // super(options);

        const controlElement = document.createElement('div');
        controlElement.classList.add('ol-location');
        controlElement.classList.add('ol-unselectable');
        controlElement.classList.add('ol-control');

        const button: HTMLButtonElement = document.createElement('button');
        button.id = 'button_geolocation';

        button.appendChild(options.svg);

        super({
            ...options,
            ...{
                element: controlElement,
                target: options.target,
            },
        });

        this.gotoPositionListener = () => {
            this.position$
                .pipe(
                    take(1),
                    tap((position: CustomGeoPosition) => options.locationCallback(position)),
                    tap(options.orientationCallback)
                )
                .subscribe();
        };

        this.element.appendChild(button);

        // Control.call(this, {
        //     element: this.element,
        //     target: options.target,
        // });

        this.geolocationEnabled$.pipe(distinctUntilChanged()).subscribe((enabled) => {
            if (enabled) {
                this.enable();
            } else {
                this.disable();
            }
        });
    }

    disable() {
        const button = this.element.firstElementChild as HTMLButtonElement;
        button.disabled = true;
        button.removeEventListener('click', this.gotoPositionListener);
        button.removeEventListener('touchstart', this.gotoPositionListener);
    }

    enable() {
        const button = this.element.firstElementChild as HTMLButtonElement;
        button.disabled = false;
        button.addEventListener('click', this.gotoPositionListener);
        button.addEventListener('touchstart', this.gotoPositionListener);
    }
}
